import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AllRoutes from "./routes";
import IdleLogout from "./components/IdleLogout";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Helmet>
            <title>Smart Hotel SHE</title>
            <meta name="description" content="Booking Management" />
            <meta name="theme-color" content="#000000" />
          </Helmet>
          <IdleLogout />
          <AllRoutes />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
